import { render, staticRenderFns } from "./ResidentAgingTab.vue?vue&type=template&id=5893f293&scoped=true&"
import script from "./ResidentAgingTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentAgingTab.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentAgingTab.vue?vue&type=style&index=0&id=5893f293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5893f293",
  null
  
)

export default component.exports